import styled from 'styled-components';
import SvgInfo from '../../../../others/svg_dist/Info';

export const Wrapper = styled.div`
	height: 250px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-image: linear-gradient(45deg, #002962, #004583);
	flex-flow: column nowrap;
	scroll-margin-top: 200px;
	@media screen and (max-width: 900px) {
		height: auto;
		padding: 50px 0;
	}
`;

export const BottomContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	margin-top: 30px;
	@media screen and (max-width: 900px) {
		flex-flow: column nowrap;
	}
`;

export const TopFont = styled.p`
	color: #fff;
	font-size: 21px;
	font-weight: 600;
	margin: 0;
	margin-left: 10px;
	@media screen and (max-width: 650px) {
		margin: 0 20px;
		margin-left: 10px;
		text-align: center;
	}
`;

export const DateFont = styled.p`
	color: #d2d2d2;
	font-size: 15px;
	margin-right: 6px;
	span {
		font-weight: 600;
		color: #fff;
	}
	@media screen and (max-width: 900px) {
		margin-right: 0;
	}
`;

export const DecorContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	margin-right: 25px;
	svg {
		rotate: 270deg;
		width: 22px;
		height: 22px;
		fill: #04a4ec;
	}
	@media screen and (max-width: 900px) {
		margin-right: 0;
		svg {
			rotate: 0deg;
		}
	}
`;

export const StyledSvgInfo = styled(SvgInfo)`
	width: 35px;
	height: 35px;
	fill: #d66464;
`;

export const TopFontContainer = styled.div`
	display: flex;
	align-items: center;
`;
